import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qt6snjtwq: FaireProductEntity = {
  token: "p_2qt6snjtwq",
  type: "product",
  name: "Grip Socks Counter POP Display",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/3df11b616bb95b6ab64fa45526888fba7dc48b90b0bf5583da5b08a111feff55.png",
  galleryImageUrls: [],
  priceDollars: 0.01,
  description: "(Limit: 2 displays per store location)\n\nA great way to showcase your Gumball Poodle Grip socks!\n\nIntroducing our 4-pocket cardboard counter display!\nFree with a minimum order of 24 pairs of grip socks, any styles of your choice. You pick the grip socks you love!\n\n• Holds up to 4 different styles, and 24 pairs.\n• Features a compact footprint, that holds a total suggested retail value of $480.\n• Comes assembled with easy-to-attach header.\n• Made of sturdy cardboard right here in the USA.\n\nFree with minimum purchase of 24 pairs of grip socks.\n\nMeasures: 17\" wide, 10\" tall, 11.5\" deep\n\nPlace on a counter, a table, a shelf–anywhere Gumball Poodle Grip socks will shine!",
  tags: [],
  msrpDollars: 0.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:27.252Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
